import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {create_UUID, showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import DividedTable from "../../components/Table/DividedTable";
import Alert from "react-s-alert";
import * as headerContent from "../../constants/exportcontent";

class Balance extends Component {

    constructor(props) {
        super(props);

        this.state = {
            stats: [],
            statSums: [],
            transactionTypes: [],
            transactionChannels: [],
            cities: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
        };

        this.listPaymentTypes = this.listPaymentTypes.bind(this);
        this.listStats = this.listStats.bind(this);
        this.listStatSums = this.listStatSums.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.listPaymentTypes();
        this.listTransactionChannels();
        this.listStats();
        this.listStatSums();
    }

    listPaymentTypes() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-type/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionTypes = response.data;
                self.setState({
                    transactionTypes,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listStats() {
        let self = this;
        let searchQuery = !self.state.searchQuery ? '' : '?' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + "/financial-transaction/fetchStats/" + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let stats = response.data;
                self.setState({
                    stats,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listStatSums() {
        let self = this;
        let searchQuery = !self.state.searchQuery ? '' : '?' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + "/financial-transaction/fetchStatSums/" + searchQuery,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let statSums = response.data;
                //console.log("statSums",statSums);
                self.setState({
                    statSums,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listTransactionChannels() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-channel/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionChannels = response.data;
                //console.log("transactionChannels",transactionChannels);
                self.setState({
                    transactionChannels,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        console.log("searchQuery", searchQuery);
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listStats());

        this.setState({
            searchQuery,
            searching: true
        }, () => this.listStatSums())
    }

    arrangeDataSet() {
        let dataSet = {};
        dataSet.headers = headerContent.balanceContent;
        dataSet.sheetName = 'Bilanço';
        dataSet.uuid = create_UUID();
        dataSet.transactionTypes = this.state.transactionTypes;
        dataSet.transactionChannels = this.state.transactionChannels;
        dataSet.statSums = this.state.statSums;
        dataSet.stats = this.state.stats;
        return dataSet;
    }

    async exportXls() {
        let self = this;
        let data = self.arrangeDataSet();
        let params = {
            url: API_BASE_URL + '/financial-transaction/downloadReportBalance',
            method: "post",
            data: data,
        };
        Alert.success(
            "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'İNDİRME TALEPLERİNİZ'" +
            " butonuna tıklayarak excel dosyasını indirebilirsiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 10000
            });
        await request(params).then(function (response) {
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {
        let transactionTypes = [];
        let branchSelectdata;
        const {branches} = this.props;
        transactionTypes = this.state.transactionTypes;
        const branchHeader = [{value: null, label: "Tümü"}, {value: "0", label: "BİRLİK MERKEZİ"},];
        branches ? branchSelectdata = branchHeader.concat(branches) : branchSelectdata = branchHeader;

        const columns1 = [
            {
                Header: "Gelir Tipi",
                width: "50%",
                accessor: "",
            //     Cell: item => (
            //         <label>{(transactionTypes.length > 0 && item.value) ? transactionTypes[item.value - 1].name.toString() : ''}</label>)
            },
            {
                Header: "Toplam Tutar",
                width: "50%",
                accessor: "label",
            },
        ];

        const columns2 = [
            {
                Header: "Gider Tipi",
                accessor: "",
                width: "50%",
            //     Cell: item => (
            //         <label>{(transactionTypes.length > 0 && item.value) ? transactionTypes[item.value - 1].name.toString() : ''}</label>)
            //
            },
            {
                Header: "Toplam Tutar",
                accessor: "label",
                width: "50%",
            },
        ];
        const fields = [
            {
                label: "İşlem Tarihi(..'den Sonra)",
                accessor: "min_transactionDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "İşlem Tarihi(..'den Önce)",
                accessor: "max_transactionDate2", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: "<=",
            },
        ];

        if (this.props.currentUser.realm.toString() === "0") {
            fields.push({
                label: "Oda",
                accessor: "branchId",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },);
        }

        return (
            <div className="financial-transaction-list-container">
                <div className="row baseBackground">
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">Oda Muhasebe Yönetimi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body mt-1">
                            <DividedTable
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={this.state.stats}
                                statSums={this.state.statSums}
                                total="10"
                                page="0"
                                manual={this.state.manual}
                                size="10"
                                columns1={columns1}
                                columns2={columns2}
                                paginationEnabled={false}
                                transactionTypes={transactionTypes}
                                fetchData={this.listStats}
                            />
                        </div>
                    </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Excel İndir"
                                style={{
                                    background: 'linear-gradient(#129a30, #116128)',
                                    height: '40px',
                                    width: '155px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                rel="tooltip" className="TekBtn excel "

                                onClick={() => this.exportXls()}>
                            EXCEL İNDİR
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Balance;



// WEBPACK FOOTER //
// ./src/page/financial/Balance.js